module.exports = __webpack_public_path__ + "media/btn_press.352fae33.wav";